import { definedOrThrow } from '@utils/definedOrThrow';
import packageJson from '../package.json';

export const Environment = {
  isTest: !!import.meta.env.TEST,
  SENTRY_DSN: definedOrThrow(
    'VITE_SENTRY_DSN',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    import.meta.env.VITE_SENTRY_DSN,
  ),
  PROD: import.meta.env.PROD,
  ENVIRONMENT: definedOrThrow(
    'VITE_ENVIRONMENT',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    import.meta.env.VITE_ENVIRONMENT,
  ),
  SENTRY_RELEASE: 'ivario.arc.frontend.' + packageJson.version,
  BACKEND_URL: definedOrThrow(
    'VITE_BACKEND_URL',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    import.meta.env.VITE_BACKEND_URL,
  ),
  PUBLIC_URL: definedOrThrow(
    'VITE_PUBLIC_URL',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    import.meta.env.VITE_PUBLIC_URL,
  ),
  OIDC_AUTHORITY: definedOrThrow(
    'VITE_OIDC_AUTHORITY',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    import.meta.env.VITE_OIDC_AUTHORITY,
  ),
  OIDC_CLIENT_ID: definedOrThrow(
    'VITE_OIDC_CLIENT_ID',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    import.meta.env.VITE_OIDC_CLIENT_ID,
  ),
};
